'use client';

import * as React from 'react';
import {useNavigate, useSearchParams} from 'react-router-dom';

import paths from '@src/paths';
import { useAuth } from '@src/context';

export default function GuestGuard({ children }) {
  const navigate = useNavigate();
  const { isAuthenticated, state } = useAuth();
  const [isChecking, setIsChecking] = React.useState(true);
  const [searchParams] = useSearchParams();

  const getHomePath = React.useCallback(() => {
    const user = state?.user;
    const memberships = user?.client_memberships || [];
    const isClientMember = !user?.is_staff && !user?.is_superuser && memberships.length > 0;
    if (isClientMember) {
      const primary = memberships[0] || {};
      const slug = primary?.client_slug || primary?.client_id;
      const status = primary?.client_status;
      const isOnboarding = status === 'new_business' || status === 'onboarding';
      if (slug) {
        return isOnboarding ? paths.onboarding.forClient(slug) : paths.clientDashboard(slug);
      }
      return paths.clients;
    }
    return paths.dashboard.dailyPulse;
  }, [state?.user]);

  const checkPermissions = async () => {
    if (isAuthenticated) {
      console.debug('[GuestGuard]: User is logged in, redirecting to dashboard');
      navigate(searchParams.get('next') || getHomePath(), { replace: true });
      return;
    }

    setIsChecking(false);
  };

  React.useEffect(() => {
    checkPermissions().catch(() => {
      // noop
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- Expected
  }, [isAuthenticated]);

  if (isChecking) {
    return null;
  }

  return <React.Fragment>{children}</React.Fragment>;
}
